import common from '../common';
import Command from './Command';

export default class TurnCommand extends Command {
	constructor() {
		super('ui_function_turn_bg_9slice');

		this.type = Command.TYPE_TURN;
		this.direction = null;

		this.options = ['left', 'right'];

		this.variableActive = true;
		this.defaultVariable = this.options[0];

		this.signals.onVariableTouch = new P3.utils.MiniSignal();

		this.init();

		this.variableBackground.visible = false;
		this.variableLabel.visible = false;
	}

	init() {
		super.init('GAME.BLOCKS.TURN', 'ui_icon_turn');

		this.player.signals.rotated.add(() => {
			this.signals.executionComplete.dispatch();
		});

		this.on('pointertap', (e) => {
			if (!this.canChangeVariable) {
				return;
			}
			this.signals.onVariableTouch.dispatch(this, e);
		});

		this.variableIcon = new PIXI.Sprite(P3.assets.texture('ui_icon_left_large'));
		this.variableIcon.anchor.set(0.5);
		this.variableIcon.x = (common.commandDimensions.width >> 1) - (this.variableIcon.width >> 1) - common.commandSpacing;
		this.variableIcon.y = this.yPosition;
		this.variableIcon.visible = false;

		this.addChild(this.variableIcon);
	}

	setText(text) {
		this.variableIcon.texture = P3.assets.texture(`ui_icon_${text.toLowerCase()}_large`);

		this.variableIcon.visible = true;
	}

	onPointerMove(event) {
		super.onPointerMove(event);

		/* if (this.y - this.height * 0.5 < 0) {
			this.y = this.height * 0.5;
		} else if (this.y + this.height * 0.5 > common.STAGE_HEIGHT) {
			this.y = common.STAGE_HEIGHT - this.height * 0.5;
		} */
	}

	execute() {
		const rad = this.variable === this.options[0] ? 90 * PIXI.DEG_TO_RAD : -90 * PIXI.DEG_TO_RAD;

		this.player.mesh.spine.state.setAnimation(0, this.player.animations.idle, true);

		this.player.rotate(rad, 600);
	}
}
